export default __webpack_public_path__ + "static/media/NOTIFICATIONHEADER.39a7a065.png";